module.exports = __webpack_public_path__ + "static/media/kkaeda-dragon.84b85dfb.png";